import React from 'react';
import styled from '@emotion/styled';
import { ITheme } from '../../../../ui';
// eslint-disable-next-line no-restricted-imports
import { useRouter } from 'next/router';
import { getMapUrlForPoiId } from './helpers/getMapUrlForPoiId';
import { useLocale } from '../../../shared/i18n/locale/useLocale';
import themed from '../../../../ui/themer/themed';

const IframeWrap = styled.div<{}, ITheme>`
	position: relative;
	padding-bottom: 60%;
	background: ${themed(({ background }) => background.light)};

	@media (orientation: portrait) {
		padding-bottom: 70vh;
	}
`;

const StyledIframe = styled.iframe`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	border: 0;
`;

export const PoiMap = () => {
	const { query } = useRouter();
	const poiId = query.poiId as string;
	const currentLocale = useLocale();

	return (
		<IframeWrap>
			<StyledIframe
				key={poiId}
				src={getMapUrlForPoiId(currentLocale, poiId)}
				title="Airport Points of Interest Map"
			/>
		</IframeWrap>
	);
};
